import FootballStatsCategory from "../../stats/football-stats-category";
import FootballState from "../../state/football-state";
import StatsRule from "../../../common/stats-rule";
import TeamLoss from "../../enums/team-loss";

export default class KneelDownStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { teamLossOnly } = gameContext.gameConfig.general || {};
        const kneelTeamLossOnly = teamLossOnly?.some(
            (code) => code === TeamLoss.KneelDown.code
        );

        return (
            fragment.associatedState === FootballState.KneelDown &&
            !kneelTeamLossOnly &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { kneelBy, kneeledAt } = fragment;

        const yards =
            (kneeledAt - gameContext.fieldPosition) *
            gameContext.getFieldDirectionMultiplier();

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: kneelBy.teamId,
            playerId: kneelBy.id,
            driveId: gameContext.currentDriveId,
            fragmentId: fragment.id,
            category: FootballStatsCategory.KNEEL_DOWN,
            values: {
                completed: 1,
                attempted: 1,
                yards
            }
        });
    }
}
